type BtnVariant = 'primary' | 'accent' | 'outline' | 'ghost' | 'light';
type BtnSize = 'sm' | 'md' | 'lg';

export const btn = (variant: BtnVariant = 'primary', size: BtnSize = 'md'): string => {
  const base =
    'inline-flex items-center justify-center gap-2 rounded-md font-label font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background-50';

  const sizes: Record<BtnSize, string> = {
    sm: 'px-3.5 py-1.5 text-xs',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-7 py-3 text-[15px]',
  };

  const variants: Record<BtnVariant, string> = {
    primary: 'bg-primary-500 text-background-50 hover:bg-primary-600 dark:text-foreground-950',
    accent: 'bg-accent-500 text-foreground-950 hover:bg-accent-600',
    outline:
      'border border-foreground-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 bg-transparent',
    ghost: 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950',
    light: 'bg-background-50 text-foreground-900 hover:bg-background-100',
  };

  return `${base} ${sizes[size]} ${variants[variant]}`;
};

export const pillClass =
  'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-label font-medium whitespace-nowrap';

export const shellClass = 'mx-auto w-full max-w-shell px-4 md:px-8';